import { Grid } from "@mui/material"
import { useAppLocalization } from "../../../localization/components/AppLocalizationProvider"
import { ErrorView } from "../../../../shared/components/errors/ErrorView"
import { StandardDialog } from "../../../../shared/components/dialogs/StandardDialog"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import GeneralErrorAnim from "../../../../shared/assets/general-error-lottie-anim.json"
import { useApiQuery } from "../../../../core/api/useApiQuery"
import { fetchDeviceDetails } from "../deviceApi"
import { DeviceDetailsContainer, DeviceDetailsSkeleton } from "./DeviceDetailsDialogElements"
import { DeviceDetailsDialogHistorySection } from "./DeviceDetailsDialogHistorySection"
import { DeviceDetailsDialogStatusSection } from "./DeviceDetailsDialogStatusSection"
import { DeviceDetailsDialogGroupSection } from "./DeviceDetailsDialogGroupSection"
import { DeviceDetailsDialogDeviceTypeSection } from "./DeviceDetailsDialogDeviceTypeSection"
import { DeviceDetailsDialogSettingsSection } from "./DeviceDetailsDialogSettingsSection"
import { DeviceDetailsDialogInfoSection } from "./DeviceDetailsDialogInfoSection"

type DeviceDetailsDialogProps = Readonly<{ deviceId: number; open: boolean; onClose: () => void }>

export function DeviceDetailsDialog({ deviceId, open, onClose }: DeviceDetailsDialogProps) {
    const { l10n } = useAppLocalization()

    const deviceDetailsResult = useApiQuery(fetchDeviceDetails, {
        queryName: "details-for-device",
        dependencies: {
            deviceId,
        },
    })

    const deviceDetailsData = deviceDetailsResult.data?.device

    return (
        <>
            <StandardDialog
                dialogTitle={
                    <LocalizedStrict id="device-details-title">
                        <>Device details</>
                    </LocalizedStrict>
                }
                open={open}
                onClose={onClose}
                maxWidthProp="lg"
                scroll="body"
            >
                {!deviceDetailsResult.isError && (
                    <DeviceDetailsContainer>
                        {!deviceDetailsResult.isLoading && deviceDetailsData ? (
                            <>
                                <DeviceDetailsDialogDeviceTypeSection type={deviceDetailsData.type} />
                                <DeviceDetailsDialogInfoSection deviceDetailsData={deviceDetailsData} />
                                <DeviceDetailsDialogStatusSection
                                    deviceId={deviceId}
                                    statusDetails={deviceDetailsData.statusDetails}
                                />
                                <Grid container gap={5} flexWrap="nowrap">
                                    <Grid item xs={7}>
                                        <DeviceDetailsDialogSettingsSection deviceDetailsData={deviceDetailsData} />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <DeviceDetailsDialogHistorySection history={deviceDetailsData.history} />
                                    </Grid>
                                </Grid>

                                {deviceDetailsData.deviceGroup && (
                                    <DeviceDetailsDialogGroupSection deviceGroup={deviceDetailsData.deviceGroup} />
                                )}
                            </>
                        ) : (
                            <DeviceDetailsSkeleton />
                        )}
                    </DeviceDetailsContainer>
                )}
                {deviceDetailsResult.isError && (
                    <ErrorView
                        lottieAnimation={GeneralErrorAnim}
                        title="A problem occurred"
                        message="Failed to load receipt"
                        buttonLabel="Close"
                        onClose={onClose}
                    />
                )}
            </StandardDialog>
        </>
    )
}
